import { ReactNode } from "react";
import { View } from "./View";

export interface IBalanceData {
  reactKey: string;
  availableBalance: number;
  ledgerBalance: number;
  currency_symbol: string;
  description: string;
}

export interface IBalancesTableProps {
  data: IBalanceData[];
  total: IBalanceData;
  title: string;
  subtitle: string;
  navigateButton?: ReactNode;
}

export const AvailableAndDisputeBalance = (props: IBalancesTableProps) => {
  return <View navigateButton={props.navigateButton} {...props} />;
};
